<script lang="ts">
  import { run } from "svelte/legacy";

  interface Props {
    iconSize: number;
    show?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
    lang?: string;
    describedBy?: string;
  }

  let {
    iconSize,
    show = $bindable(false),
    class: className,
    children,
    lang,
    describedBy,
  }: Props = $props();
  let btn: HTMLButtonElement;
  let wrapper = $state<HTMLDivElement>();

  // Generate unique ID for the popup content
  const popupId = `info-popup-${Math.random().toString(36).substr(2, 9)}`;

  const toggleButton = (event: MouseEvent) => {
    show = !show;
    if (show) {
    }
  };
  const onMouseClick = (event: MouseEvent) => {
    if (show && !btn.contains(event.target as Node) && !wrapper?.contains(event.target as Node)) {
      show = !show;
    }
  };

  let tooltipStyle = $state("");

  $effect(() => {
    if (show && wrapper && btn) {
      const tipRect = wrapper.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      const parentRect = btn.parentElement!.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const padx = 8;
      const offsety = 10;
      const smBreakpoint = 640;
      const offsetx = vw >= smBreakpoint ? tipRect.width / 2 - 2 * padx : 0;

      // Default: above button, centered horizontally (+ horizontal offset on larger screens)
      let top = btnRect.top - tipRect.height - offsety;
      let left = btnRect.left + (btnRect.width - tipRect.width) / 2 + offsetx;

      // Flip below if no room above
      if (top < padx) top = btnRect.bottom + offsety;
      // Push up if it still overflows the bottom
      if (top + tipRect.height > vh - padx) top = vh - padx - tipRect.height;

      // Clamp horizontally
      if (left + tipRect.width > vw - padx) left = vw - padx - tipRect.width;
      if (left < padx) left = padx;

      // Convert viewport coords to offset-parent-relative coords
      tooltipStyle = `top: ${top - parentRect.top}px; left: ${left - parentRect.left}px; `;
    } else {
      tooltipStyle = "";
    }
  });
</script>

<div class="relative">
  <button
    type="button"
    class="information-button"
    onclick={(event) => toggleButton(event)}
    bind:this={btn}
    aria-label="Visa mer information"
    aria-expanded={show}
    aria-controls={show ? popupId : undefined}
    aria-describedby={describedBy}
  >
    <div class={className}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
          stroke="currentcolor"
          stroke-width="2"
        />
        <path d="M10.5 6H11" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
        <path
          d="M9 10H11V15"
          stroke="currentcolor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 15H13"
          stroke="currentcolor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </button>
  {#if show}
    <!-- No fade-in on this popup: it is an overlay with z-index 100. The
         fade-in's opacity < 1 keyframes make it its own stacking context while
         animating, which stops the z-index from lifting it above nearby
         overlays (e.g. the datepicker). Show it without the opacity fade. -->
    <div
      bind:this={wrapper}
      id={popupId}
      role="tooltip"
      aria-hidden={show}
      class="information-description rounded-sm shadow-md absolute w-60 md:w-80 text-sm md:text-base text-left text-Neutral110 p-2 bg-PurplePrimary"
      style={tooltipStyle + " z-index: 100;"}
      aria-controls="information-description"
      {lang}
    >
      {@render children?.()}
    </div>
  {/if}
</div>
<svelte:body onmousedown={onMouseClick} />
